import React, {useState} from "react";
import "./Ear.sass"
import useResizeAware from 'react-resize-aware';
import Getter from "../Getter";
import {ReactComponent as LeftEar} from "../../svg/LeftEar.svg";

const imageUrl = `${process.env.PUBLIC_URL}/imgs/ear.jpg`;

const isDisabled = (currentItemType,acceptableGetters,realIndex,  accepts) => {
    if(currentItemType === null){
        return true
    }
    if(acceptableGetters.length > 0){
        return !acceptableGetters.includes(realIndex)
    }
    return !accepts.includes(currentItemType)
};

const Ear = ({getters, currentItemType, acceptableGetters}) => {
    const [resizeListener, sizes] = useResizeAware();
    const [rightEar, setLeftActive] = useState(true);
    let size = sizes.width / 13.33;
    let transformedOffset = sizes.width / 26.67;
    size = Number(size.toFixed(2))
    const offset = size / 2;
    return (
        <div className="Ear">
            <div className="Ear-buttons">
                <div
                    className={`Ear-button ${!rightEar? "Ear-button-active" : ""}`}
                    onClick={() => setLeftActive(false)}
                >
                    <LeftEar />
                </div>
                <div
                    className={`Ear-button ${rightEar ? "Ear-button-active" : ""}`}
                    onClick={() => setLeftActive(true)}
                >
                    <LeftEar />
                </div>
            </div>
            <div className={`Ear-wrapper ${rightEar ? "Ear-wrapper-active" : ""}`}>
                {resizeListener}
                <img className="Ear-img" src={imageUrl} alt=""/>
                {getters.map(({ accepts, droppedItem, id , realIndex}, index) =>
                        index < 11 && <Getter
                                index={index}
                                className={`Ear-pin pin-${index}`}
                                style={{
                                    width:size, height: size,
                                    marginTop: -offset, marginLeft: -offset
                                }}
                                isDropDisabled={isDisabled(currentItemType,acceptableGetters,realIndex,  accepts)}
                                droppedItem={droppedItem}
                                key={index}
                                realIndex={realIndex}
                            />
                )}
            </div>
            <div className={`Ear-wrapper Ear-wrapper-left ${!rightEar ? "Ear-wrapper-active" : ""}`}>
                <img className="Ear-img" src={imageUrl} alt=""/>
                {getters.map(({ accepts, droppedItem, id, realIndex }, index) =>
                    index > 10 && <Getter
                        index={index}
                        className={`Ear-pin pin-${index}`}
                        style={{width:size, height: size, marginLeft: -offset, marginTop: -offset, marginRight: -transformedOffset}}
                        isDropDisabled={isDisabled(currentItemType,acceptableGetters,realIndex,  accepts)}
                        droppedItem={droppedItem}
                        key={index}
                        realIndex={realIndex}
                    />
                )}
            </div>
        </div>
    )
};

export default Ear
